<template>
    <header>
        <div class="h-[5.5em]"></div>
        <div class="relative">
            <div :class="{ 'shadow-md': isScrolled }" class="transition-shadow fixed w-full bg-primary top-0 z-[99]">
                <div class="__sides relative flex items-center justify-between h-[5.5em]">
                    <BurgerMenuIcon @event="handleMenuEvent" class="md:hidden border-none" menuColor="#fff"/>
                    <router-link :class="getShowModalSearch() ? 'hidden sm:block': ''" class=" text-2xl center-title font-bold text-gray-800 hover:text-gray-600 lg:text-3xl" to="/home">
                        <div class="w-full text-center rounded-md">
                            <div class="flex gap-2">
                            <img alt="Vue logo" src="@/assets/simbolo-CETE.png" class="h-9 sm:h-12 bg-transparent">
                                <div class="text-white text-sm sm:text-xl">
                                    <div class="grid text-left">
                                        <span class="mx-0.5 sm:-mb-2 text-[12px] font-thin">Especialização em</span>
                                        <span class="font-bold text-sm sm:text-xl whitespace-nowrap">Trauma do Esporte
                                            <span class="italic text-xs sm:text-xl">EAD</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                    <nav class="hidden md:flex mx-2">
                        <span v-for="(link, index) in getItensNavbar" :key="link.name">
                            <a v-if="link.target" :href="link.path" :target="link.target" rel="noopener noreferrer" class="__link px-2" @mouseover="getNavSecundaria(index)">
                                {{ link.name }}
                            </a>
                            <router-link v-else class="__link px-2" :to="link.path" @mouseover="getNavSecundaria(index)">
                                {{link.name}}
                            </router-link>
                        </span>
                    </nav>
                    <div class="flex items-center space-x-1 lg:space-x-6">
                        <span v-if="!getShowModalSearch()">
                            <router-link v-if="!$store.state.user.user" to="/auth" class="hidden __link md:block">LOGIN</router-link>
                            <router-link v-else to="/profile/account" class="hidden __link md:block">Minha conta</router-link>
                        </span>
                        <!-- Barra de Pesquisa -->
                        <form class="flex items-center justify-between">   
                            <input v-show="getShowModalSearch()" v-model="$store.state.aulas.keyword" @input="onSearch" type="text" name="Busca" class="min-w-[70vw] lg:min-w-[40vw] border-b-2 border-[rgb(31 41 55)] -bottom-1 text-gray-900 text-sm block w-full p-2.5 mx-2" placeholder="Buscar pela Aula ..." required>
                            <button @click="SET_SHOW_MODAL_SEARCH(!getShowModalSearch()), $store.state.aulas.keyword = ''" type="submit" class="relative text-gray-700 hover:text-gray-600 bg-transparent __link">
                                <svg v-if="getShowModalSearch()" class="fill-current text-white w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                                <svg v-else class="fill-current text-white w-7 h-7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
                            </button>
                        </form>
                        <router-link v-if="$store.state.user.user" to="/notification" class="relative text-gray-700 __link">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                            </svg>
                            <span v-if="countUnreadNotifications" class="absolute -top-1.5 left-4 px-1 py-0.5 text-[0.55rem] text-white bg-red-500 rounded-full">{{ countUnreadNotifications }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
            <Modal_Search v-show="getShowModalSearch()" />
        </div>
        <!-- Itens dentro do Burger -->
        <div class="md:hidden" :class="showThisCommponent ? 'block md:hidden' : 'hidden'">
            <div :class="isMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'" class="bg-white fixed z-[98] transition-all duration-300 bottom-0 p-4 divide-y top-[5.5em] min-h-screen w-screen dark:bg-black">
                <span v-for="link in getItensNavbar" :key="link.name" :to="link.path" class="text-lg py-2 block">
                    <a v-if="link.target" :href="link.path" :target="link.target" rel="noopener noreferrer" class="text-lg py-2 block">
                        {{ link.name }}
                    </a>
                    <router-link v-else class="text-lg py-2 block" :to="link.path" >
                        {{link.name}}
                    </router-link>
                </span>

                <router-link v-if="!$store.state.user.user" to="/auth" class="text-lg py-2 block">LOGIN</router-link>
                <router-link v-else to="/profile/account" class="text-lg py-2 block">Minha conta</router-link>
            </div>
        </div>
        <!-- Fim dos itens dentro do Burger -->
    </header>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { debounce } from 'lodash';
    import BurgerMenuIcon from '@/components/header/BurgerMenuIcon.vue';
    import Modal_Search from '@/components/search/Modal_Search.vue';
    export default {
        name: 'HeaderComponent',
        components: {
            BurgerMenuIcon,
            Modal_Search
        },
        props: {
            noBackground: {
                Type: Boolean
            },
            noBorder: {
                Type: Boolean
            }
        },
        data() {
            return {
                isMenuOpen: false,
                isScrolled: false,
                showThisCommponent: false,
            }
        },
        mounted() {
            window.addEventListener("scroll", this.handleScroll);
        },
        methods: {
            ...mapActions(['fetchBusca']),
            ...mapGetters(['getSubjects', 'getLoadingSubject', 'getShowModalSearch']),
            ...mapMutations(['SET_SHOW_MODAL_SEARCH', 'LOG_USER_OUT']),
            search(){
                this.fetchProducts({keyword: this.$route.params.search, pageNumber: this.$route.params.pageNumber});
            },
            handleMenuEvent(evt) {
                if(evt) {
                    this.showThisCommponent = evt
                    return;
                }
                this.isMenuOpen = false;
                setTimeout(() => {
                    this.showThisCommponent = false;
                }, 310);
            },
            updateIsMenuOpen(value) {
                if(value){
                    setTimeout(() => {
                        this.isMenuOpen = value;
                    }, 2);
                }
            },
            handleScroll() {
                this.isScrolled = window.scrollY > 0;
            },
            buscarAulas() {
                this.fetchBusca({
                    keyword: this.$store.state.aulas.keyword.trim(), 
                    pageNumber: this.page
                })
            },
            debouncedSearch: debounce(function() {
                this.page = 1;
                this.buscarAulas();
            }, 500),
            onSearch() {
                this.debouncedSearch();
            },
        },
        watch: {
            showThisCommponent(value) {
                this.updateIsMenuOpen(value)
            }
        },
        computed: {
            ...mapGetters(['countUnreadNotifications', 'getItensNavbar']),
        }
    }
</script>

<style>
    @media screen and (max-width: 768px) {
        .center-title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .__link {
        color: white;
        text-decoration: none;
        position: relative;
        text-transform: uppercase;
    }

    .__link::after {
        bottom: -4px;
        content: "";
        display: block;
        height: 2px;
        left: 0;
        position: absolute;
        background: white;
        opacity: 0.6;
        transition: width 0.3s ease 0s, opacity 0.3s ease 0s;
        width: 0;
    }

    .__link:hover::after {
        width: 100%;
        opacity: 0.9;
    }
</style>